import { bindImpact } from '@/api/account';
import logger from '@/utils/client-logger';
import { env } from '@/utils/env';
import { getSetLocalStorage } from '@/utils/tools';
import { Provider, ProviderType, TrackingEvent } from '../types';

interface ImpactConfig {
  isEnabled?: boolean;
}

export class ImpactRadiusProvider implements Provider {
  type = ProviderType.IMPACT_RADIUS;
  isEnabled: boolean;
  loggingEnabled = false; // 公开属性，支持ReportingCenter访问
  private initialized = false;
  private config: ImpactConfig;

  constructor(config: ImpactConfig) {
    this.config = config;
    this.isEnabled = config.isEnabled ?? true;
    this.loggingEnabled = env.NEXT_PUBLIC_ENV === 'local';
  }

  async init(): Promise<boolean> {
    try {
      if (typeof window === 'undefined') return false;
      if (this.initialized) return true;

      this.initialized = true;
    } catch (error) {
      logger.error('Failed to initialize Impact Radius:', error);
      return false;
    }
  }

  track(event: TrackingEvent): void {
    // Impact Radius 的事件追踪都是靠后端的
    if (this.loggingEnabled) {
      logger.log('Impact Radius tracking event:', event);
    }
  }

  async bindImpact(token?: string, onSuccess?: () => void): Promise<void> {
    // 绑定impact
    // 从 URL 参数或 localStorage 获取 irclickid
    const urlParams = new URLSearchParams(window.location.search);
    const irclickid = urlParams.get('irclickid') || getSetLocalStorage.get('irclickid');

    if (irclickid) {
      const date = new Date().getTime();
      // 设置 30 天过期时间
      getSetLocalStorage.set('irclickid', irclickid, date + 30 * 24 * 60 * 60 * 1000);

      if (token) {
        try {
          // 【1008860】前端判断传参为空，不调接口
          const bindRes = irclickid ? await bindImpact({ irclickid }) : {};

          // 绑定成功
          if (bindRes?.code === 200) {
            if (onSuccess) {
              onSuccess();
            }
            // 绑定成功删除缓存中的irclickid，impact平台设置的有链接30天有效期
            localStorage.removeItem('irclickid');
          }
        } catch (e) {
          logger.error('bindImpact error', e);
        }
      }
    }
  }

  /**
   * 启用Impact日志
   */
  enableLog(): void {
    this.loggingEnabled = true;
  }

  /**
   * 禁用Impact日志
   */
  disableLog(): void {
    this.loggingEnabled = false;
  }

  isInitialized(): boolean {
    return this.initialized;
  }
}
